import { React, useState, useRef } from 'react';
import {
  AdjustmentsHorizontalIcon,
  ArrowsUpDownIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/20/solid';
import VenueList from '../../Components/Venue/List';
import { ReactSVG } from 'react-svg';
import { capitalize } from '../../Utils';

import { useLocation, useNavigate } from 'react-router-dom';

import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';


const AutoplaySlider = withAutoplay(AwesomeSlider);

const PageVenueList = () => {
  const navigate = useNavigate();


  const [filters, setFilters] = useState(["padel"]);
  const [sorts, setSorts] = useState(["Alfabet A - Z", "Alfabet Z - A", "Lapang Termurah", "Lapang Termahal"]);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querySearch = queryParams.get('search') ?? "";
  const [sportType, setSportType] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");

  const [kelebihan] = useState([
    {
      image: "/img-why-fityuk-1.svg",
      title: "Reservasi Lapang Mudah",
      description: "Anda tak perlu menginstall aplikasi, cukup menggunakan browser lalu mengisi nama, nomor telepon, dan email. Anda sudah dapat melakukan reservasi lapang."
    },
    {
      image: "/img-why-fityuk-2.svg",
      title: "Berbagai Macam Pilihan Jenis Olahraga",
      description: "Berbagai olahraga populer yang banyak digemari saat ini seperti sepakbola, mini soccer, futsal, badminton, tennis, padel)"
    },
    {
      image: "/img-why-fityuk-3.svg",
      title: "Berbagai Macam Pilihan Metode Pembayaran",
      description: "Fityuk menyediakan Virtual Account dari bank-bank umum, serta E-Money untuk membayar reservasi lapang anda."
    },
    {
      image: "/img-why-fityuk-4.svg",
      title: "Layanan Support",
      description: "Jika reservasi lapang anda mengalami kendala, silahkan hubungi Customer Service kami segera."
    }
  ]);

  const childRef = useRef();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='flex flex-col'>
      <div className='flex justify-center items-center bg-[#d43a3a]/80 rounded-full mx-auto px-6 py-4 lg:px-10 lg:py-4'>
        <span className='text-center text-white font-bold text-[18px] lg:text-[22px]'>
          Temukan Tempat Favoritmu untuk berolahraga
        </span>
      </div>

      <div className='rounded-2xl bg-[#fff] p-6 mt-6'>
        <div className='flex w-full justify-start'><div className="flex flex-grow">
          {/* "Semua" Button */}
          <button
            className={`
    flex 
    px-6
    py-0
    items-center 
    rounded-lg 
    border 
    border-primaryRed 
    text-[11px] 
    font-bold 
    hidden lg:flex 
    ${sportType === "" ? "text-white bg-primaryRed" : "text-primaryRed bg-white"}
  `}
            onClick={() => {
              setSportType("");
              // setSortBy("");
              childRef.current.refreshData();
            }}
          >Semua</button>

          {/* Dynamic Filter Buttons */}
          {
            filters.map((item) => (
              <button className={`flex ml-3 px-3 py-0 items-center rounded-lg border border-primaryRed text-[11px] font-bold text-primaryRed 
        hidden lg:flex 
    ${sportType === item ? "text-white bg-primaryRed" : "text-primaryRed bg-white"}`}

                onClick={() => {
                  setSportType(item);
                  // setSortBy(item);
                  childRef.current.refreshData();
                }}
              >
                <ReactSVG
                  src={`/sport-type/light/ic-${item}.svg`}
                  afterInjection={(svg) => {
                    svg.setAttribute("fill", sportType === item ? "#cfcfcf" : "#d43a3a");
                    svg.setAttribute("height", "20");
                    svg.setAttribute("width", "20");
                  }}
                />
                <span className="ml-1.5">{capitalize(item.replaceAll("-", " "))}</span>
              </button>
            ))
          }
        </div>

          <div className="relative">
            <button className='flex ml-2 px-3 py-2 border text-primaryRed font-bold text-[11px] border-primaryRed rounded-md items-center'
              onClick={() => {
                // if (sortDirection === "asc") {
                //   setSortDirection("desc");
                // } else {
                //   setSortDirection("asc");
                // }
                // childRef.current.refreshData();

                setIsOpen(!isOpen);
              }}>
              <ArrowsUpDownIcon className='w-4 text-primaryRed' />
              <span className='hidden md:inline-block ml-1.5'>Urutkan</span>
            </button>

            {/* Filter Button */}
            {/* <button
    className="flex ml-2 px-4 py-2 border text-primaryRed font-semibold text-xs border-primaryRed rounded-md items-center"
    onClick={() => {
      setIsOpen(!isOpen);
    }}
  >
    <AdjustmentsHorizontalIcon className="w-5 text-primaryRed" />
    <span className="hidden md:inline-block ml-2">Filter</span>
  </button> */}

            {/* Filter Dropdown Menu */}
            {isOpen && (
              // <div className="absolute mt-2 right-0 w-48 bg-white border border-primaryRed rounded-md shadow-lg z-10">
              //   {filters.map((item) => (
              //     <button
              //       key={item}
              //       className={`flex ml-4 px-2 py-2 items-center rounded-lg text-[13px] font-bold ${
              //         sportType === item
              //           ? "text-white bg-primaryRed"
              //           : "text-primaryRed bg-white"
              //       }`}
              //       onClick={() => {
              //         setSportType(item);
              //         childRef.current.refreshData();
              //         setIsOpen(false); // Close dropdown after selection
              //       }}
              //     >
              //       <ReactSVG
              //         src={`/sport-type/${item}.svg`}
              //         afterInjection={(svg) => {
              //           svg.setAttribute("fill", sportType === item ? "#cfcfcf" : "#d43a3a");
              //           svg.setAttribute("height", "18");
              //           svg.setAttribute("width", "18");
              //         }}
              //       />
              //       <span className="ml-2">{capitalize(item.replaceAll("-", " "))}</span>
              //     </button>
              //   ))}
              // </div>
              <div className="absolute mt-2 right-0 w-48 bg-white border border-primaryRed rounded-md shadow-lg z-10 divide-y divide-dashed">
                {sorts.map((item, index) => (
                  <button
                    key={item}
                    className={`flex w-full items-center rounded-lg text-[11px] font-bold text-primaryRed bg-white`}
                    onClick={() => {
                      switch (index) {
                        case 0:
                          setSortBy("name");
                          setSortDirection("asc");
                          break;
                        case 1:
                          setSortBy("name");
                          setSortDirection("desc");
                          break;
                        case 2:
                          setSortBy("price");
                          setSortDirection("asc");
                          break;
                        case 3:
                          setSortBy("price");
                          setSortDirection("desc");
                          break;
                      }
                      childRef.current.refreshData();
                      setIsOpen(false);
                    }}
                  >
                    <span className='px-4 py-2.5'>{capitalize(item.replaceAll("-", " "))}</span>
                  </button>
                ))}
              </div>
            )}
          </div>



        </div>

        <VenueList search={querySearch} sportType={sportType} sortBy={sortBy} sortDirection={sortDirection} ref={childRef} />

        {/* <div className=' flex flex-col mt-6 rounded-xl overflow-hidden aspect-[1210/510]'>
          <AutoplaySlider
            className='w-full h-full'
            play={true}
            bullets={true}
            buttons={false}
            cancelOnInteraction={false}
            interval={5000}
            media={[
              {
                source: '/img_promo_main_blu_1.webp',
              },
              {
                source: '/img_promo_main_blu_2.webp',
              },
            ]}
          />
        </div> */}

        <div className='flex mt-6 flex-col lg:mt-12 space-y-8 lg:flex-row lg:space-x-8 lg:space-y-0'>

          <img className='w-full lg:w-1/3 aspect-[280/171] object-cover rounded rounded-xl' src='/img-fityuk-field.webp' />

          <div className=' flex flex-col'>
            <span className='text-[27px] font-extrabold'>
              Apa itu FitYuk?
            </span>
            <span className="mt-4 text-[13px]">
              Fityuk merupakan sebuah Platform untuk memfasilitasi anda yang gemar berolahraga dan ingin memesan lapangan secara cepat, dan praktis, langsung melalui Gadget anda tanpa harus menginstall Aplikasi.
            </span>
          </div>

        </div>

        <div className=' flex flex-col mt-12'>
          <span className='text-[27px] font-extrabold'>
            Kenapa Reservasi lapang di Fityuk?
          </span>

          <div className="mt-8 grid gap-4 sm:grid-cols-1 lg:grid-cols-2">
            {
              kelebihan.map((item, index) => (
                <div key={index} className="flex flex-row space-x-6 items-start">
                  <img src={item.image} alt="Item" className="w-[75px]" />
                  <div className="flex flex-col">
                    <span className='text-[16px] font-extrabold'>{item.title}</span>
                    <span className="mt-2 text-[13px]">{item.description}</span>
                  </div>
                </div>
              ))
            }
          </div>
          <div className='flex flex-1 mt-12 relative rounded-2xl overflow-hidden'>
            <img src='/img-gabung-vendor.webp' className="w-full min-h-[250px] object-cover object-center" alt="Background" />
            <div className='absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center p-8'>
              <span className="mt-4 text-[20px] lg:text-[20px] text-white text-center">
                Mau fasilitas olahraga anda dikelola dengan mudah & professional?
              </span>
              <span className='text-[27px] lg:text-[26px] font-extrabold text-white text-center mt-2'>
                Yuk gabung Fityuk!
              </span>
              <button
                className={`
        flex 
        px-5 py-1.5 
        items-center 
        rounded-lg 
        border 
        border-primaryRed 
        text-[12px] 
        mt-6
        font-semibold 
        text-white bg-primaryRed
      `}
                onClick={() => {
                  window.location = "/learn-more";
                }}
              >
                Pelajari Lebih Lanjut
              </button>
            </div>
          </div>



        </div>
      </div>
    </div>
  )
}

export default PageVenueList;